import { useMemo } from 'react';
import type { AvatarConfig } from '@etown/shared';

interface AvatarPreviewProps {
  config: AvatarConfig;
  /** Rendert die Figur ueber den bestehenden Spiel-Renderer als data-URL. */
  snapshot: (config: AvatarConfig) => string;
}

/**
 * Live-Vorschau des Avatars als Bild. Die Figur wird vom Haupt-Renderer
 * (Spiel-Canvas) erzeugt — WYSIWYG identisch, aber OHNE zweiten WebGL-Kontext
 * (der zuvor beim Schliessen den Haupt-Canvas leer werden liess).
 */
export function AvatarPreview({ config, snapshot }: AvatarPreviewProps) {
  const src = useMemo(() => snapshot(config), [config, snapshot]);
  return (
    <div className="avatar-preview" aria-hidden="true">
      {src && <img src={src} alt="" className="avatar-preview__img" />}
    </div>
  );
}
